import { useContext } from 'react';
import { useFlow } from '@edreamsodigeo/frontend-core';
import { withFlowComponent } from '@/HOC/withFlowComponent';
import { RepricingInfoMobile, RepricingContextMobile } from './mobile';
import { RepricingInfoDesktop, RepricingContextDesktop } from './desktop';

export const RepricingInfoProvider = withFlowComponent(
  RepricingInfoMobile,
  RepricingInfoDesktop
);

export function useRepricingInfo() {
  const desktop = useContext(RepricingContextDesktop);
  const mobile = useContext(RepricingContextMobile);

  return useFlow() === 'mobile' ? mobile : desktop;
}
